export class FavoriteMedicineToFavoriteStandardMedicineStruct {
    public idMedicine: number;
    public idFavoriteStandardMedicine: number;
    public quantity: number;
    public idMeasurementUnit: number;

    public medicineName: string;

    public isValidToMedic: string; //variável para controlar como válido ou não no atendimento médico
}